import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from "@mui/material";

const UserDetailsTable = ({ data }) => {
  const { user_details, pan_details, bank_details } = data;

  const userRows = [
    { label: "Name", value: user_details.name },
    { label: "Phone", value: user_details.phone },
    { label: "Email", value: user_details.email },
    { label: "DOB", value: user_details.dob },
    { label: "PAN Number", value: user_details.pan_number },
    {
      label: "KYC Status",
      value: user_details.kyc_status ? "Verified" : "Pending",
    },
    {
      label: "Account Status",
      value: user_details.account_status ? "Active" : "Inactive",
    },
    { label: "Country", value: user_details.country },
    { label: "State", value: user_details.state },
    { label: "City", value: user_details.city },
    { label: "Partner Username", value: user_details.partner_username },
  ];

  const panRows = [
    { label: "Name on Card", value: pan_details.msg?.NameOnTheCard },
    { label: "PAN Number", value: pan_details.msg?.PanNumber },
    { label: "DOB", value: pan_details.msg?.dob },
    { label: "Email", value: pan_details.msg?.email },
    { label: "Status", value: pan_details.msg?.STATUS },
  ];

  const bankRows = [
    { label: "Account Holder", value: bank_details?.msg?.name || "Null" },
    { label: "Account Number", value: bank_details?.msg?.account_no || "Null" },
    { label: "IFSC Code", value: bank_details?.msg?.ifsc || "Null" },
    { label: "Verification Status", value: bank_details?.msg?.status || "Null" },
  ];

  const renderRows = (rows) =>
    rows.map((row, idx) => (
      <TableRow key={idx}>
        <TableCell component="th" scope="row">
          {row.label}
        </TableCell>
        <TableCell>{row.value}</TableCell>
      </TableRow>
    ));

  return (
    <TableContainer component={Paper} sx={{ mt: 3 }}>
      <Typography color="blue" variant="h6" sx={{ p: 2 }}>
        User Details
      </Typography>
      <Table>
        <TableBody>{renderRows(userRows)}</TableBody>
      </Table>

      <Typography color="blue" variant="h6" sx={{ p: 2 }}>
        PAN Details
      </Typography>
      <Table>
        <TableBody>{renderRows(panRows)}</TableBody>
      </Table>

      <Typography color="blue" variant="h6" sx={{ p: 2 }}>
        Bank Details
      </Typography>
      <Table>
        <TableBody>{renderRows(bankRows)}</TableBody>
      </Table>
    </TableContainer>
  );
};

export default UserDetailsTable;
